import { Button } from "@/shared/ui/button.tsx"
import { useGetSingleCampaign } from "../../api/campaign"
import ChatCard from '../ChatCard'
import CampaignCard from "../campaign-selection/CampaignCard"
import { Home } from "lucide-react"
import { ChatMessageType } from "../../types"
import { useGetSingleImage } from "../../api/templates"
import { useNavigate } from "react-router-dom"

type Props = {
  event_id: number,
  setStep: (id: ChatMessageType) => void,
  imageId?: number,
  onThemeSelect: (id: number, nav: string, story_id: number) => void,
  onReasoning: (name: string, why: string) => void
}

const StorySelection = ({ event_id, imageId ,onThemeSelect, setStep, onReasoning }: Props) => {

  const { campaignStories } = useGetSingleCampaign(event_id, imageId)

  const { imageData } = useGetSingleImage(imageId)

  const navigate = useNavigate()

  return (
    <>
      <ChatCard user="client">
        <div className="w-full flex justify-between flex-col-reverse sm:flex-row items-end sm:items-center gap-3">

          <div className='flex items-center gap-1'>
            <Button
              onClick={() => setStep("navigation")}
              variant="outline"
              size="icon"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              <Home />
            </Button>
            <Button
              onClick={() => {
                if(imageId){
                  navigate(-1)
                } else {
                setStep("campaign")
                }
              }}
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              Return
            </Button>
          </div>
          <p className="tracking-wide text-gray-500 font-poppins text-sm max-sm:pt-2">I want to checkout {campaignStories?.data.event_name}</p>
        </div>
      </ChatCard>
      <ChatCard user="assistant" key="first">
        <div className="w-full flex flex-col gap-2">
          <h2 className="w-full text-lg font-montserrat font-medium">{campaignStories?.data.event_name}</h2>
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 md:grid-rows-3 gap-3">
            {campaignStories && campaignStories.data.stories.map(item => (
              <CampaignCard
                type="create"
                id={item.sequence_order}
                image_id={imageId}
                image_url={imageData?.image_url}
                data={item} event_id={event_id} key={item.story_id} onThemeSelect={onThemeSelect} onReasoning={onReasoning} />
            ))}
          </div>
        </div>
      </ChatCard>
    </>
  )
}

export default StorySelection;
